<template>
	<div class="w-full h-full">
		<van-nav-bar
			left-text="返回"
			left-arrow
			@click-left="back"
		/>
		<div class="w-full recharge">
			<div class="recharge-top">
				<div class="recharge-top-t">账号可用余额</div>
				<div class="recharge-top-b">{{ userDatalt.redBalance }}</div>
			</div>
			<div class="recharge-c">
				<div class="recharge-c-t layout-left-center">充值包服务</div>
				<div class="recharge-c-c">
					<div class="flex flex-wrap" style="margin: 0 -6px;">
						<div
							v-for="(item,index) in tenantServicePacks"
							:key="index"
							class="item-col"
							@click="onSelected(item)"
						>
							<div
								class="recharge-c-c-i w-full layout-center"
								:class="{ 'recharge-c-c-i-selected': selected.id === item.id }"
							>
								{{ item.money }}
							</div>
						</div>
					</div>
				</div>
				<div class="recharge-c-tips">
					<div class="layout-left-center">充值说明：</div>
					<div class="layout-left-center">1.若充值未到账，请及时联系客服</div>
				</div>
				<div class="recharge-c-b layout-side" v-if="selected.id">
					<div class="recharge-c-b-l"><span>￥</span>{{ selected.money }}</div>
					<div class="recharge-c-b-r layout-center" @click="onPaymentAffirm">
						确定支付
					</div>
				</div>
			</div>
		</div>

		<van-popup @close="onClose" round :style="{ height: '60%' }" v-model="showOne" position="bottom" class="popup-one">
			<div class="popup-one-a layout-center">确认订单</div>
			<div class="popup-one-b layout-center">实付金额</div>
			<div class="popup-one-c layout-center">
				<span
					style="font-size: var(--base-px-18);display: block;margin-top: var(--base-px-12);margin-right: var(--base-px-2)">￥</span>{{
					selected.money
				}}
			</div>
			<div class="popup-one-d layout-side">
				<div>支付方式</div>
				<div>微信支付</div>
			</div>
			<div class="popup-one-e layout-side">
				<div>充值说明</div>
				<div>请仔细核对，充错无法退回哦</div>
			</div>
			<div class="w-full" style="position: absolute;bottom: var(--base-px-40);right: 0;left: 0;padding: 0 var(--base-px-24)">
				<div class="popup-one-f layout-side">
					<div class="popup-one-f-l layout-center" @click="onClose">取消</div>
					<div class="popup-one-f-r layout-center" @click="onPayment">立即支付</div>
				</div>
			</div>
		</van-popup>
		<van-popup round v-model="showQRcode">
			<div class="qr-code">
				<div class="qr-code-title layout-center">微信扫一扫</div>
				<div class="qr-code-img layout-center">
					<canvas class=" w-full h-full" id="qrcode"></canvas>
				</div>
				<div class="qr-code-buttons layout-side">
					<div class="layout-center h-full" @click="onReset"
					     style="width:50%;border-right: var(--base-px-1) solid #CCCCCC;">取消
					</div>
					<div class="layout-center h-full" @click="onOk" style="width:50%;color: #1A89F9;">已完成支付</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>
import {defineComponent} from 'vue'
import {userCenter} from "../../api/homePage";
import {tenantServicePackList, tenantServicePackPay} from '../../api/my'

export default defineComponent({
	name: "recharge",
	data() {
		return {
			userDatalt: {
				name: ''
			},
			tenantServicePacks: [],
			selected: {id: ''},
			showOne: false,
			showQRcode: false,
		}
	},
	created() {
		if (localStorage.getItem("debug") === 'true') {
			this.debug = true
		} else {
			this.debug = false
		}
		this.userDetails()
		tenantServicePackList().then(res => {
			if (res.code === 200) {
				this.tenantServicePacks = res.data
			}

		})
	},
	methods: {
		back() {
			this.$router.back()
		},
		onClose() {
			console.log(this.showOne)
			this.showOne = false
		},
		onReset() {
			this.showOne = false
			this.showQRcode = false
			this.$toast.error('取消支付');
		},
		onOk() {
			this.showQRcode = false
			this.showOne = false
			this.$router.push('/my')
		},
		userDetails() {
			userCenter().then(res => {
				this.userDatalt = res.data.baseInfo
			})
		},
		onSelected(item) {
			this.selected = item

		},
		onPaymentAffirm() {
			this.showOne = true
		},
		onPayment() {
			tenantServicePackPay({
				money: this.selected.money
			}).then(res => {
				console.log(res)
				this.showQRcode = true
				this.showOne = false
				this.$nextTick(() => {
					const container = document.getElementById('qrcode');

					// 清空容器
					container.innerHTML = '';
					console.log(container)
					// 创建二维码（Canvas方式）
					QRCode.toCanvas(container, res.data.url, {
						width: 180,
						margin: 1,
						color: {
							dark: '#000000',   // 二维码颜色
							light: '#ffffff'  // 背景色
						}
					}, function (error) {
						if (error) console.error(error);
					});
				})
			})
		}
	}
})
</script>
<style scoped lang="less">
.flex {
	display: flex;
}

.flex-wrap {
	flex-wrap: wrap;
}

.qr-code {
	width: var(--base-px-281);
	height: var(--base-px-312);
	background: #ffffff;
	padding-top: var(--base-px-24);

	&-title {
		font-weight: bold;
		font-size: var(--base-px-14);
		color: #333333;
	}

	&-img {
		padding: 0 var(--base-px-50);
		margin-top: var(--base-px-20);
		width: 100%;
		height: calc(100% - var(--base-px-119));
	}

	&-buttons {
		margin-top: var(--base-px-25);
		border-top: var(--base-px-1) solid #CCCCCC;
		height: var(--base-px-52);
		font-weight: 500;
		font-size: var(--base-px-14);
		color: #333333;
	}
}

.popup-one {
	padding: 0 var(--base-px-24);

	&-a {
		padding-top: var(--base-px-14);
		font-weight: bold;
		font-size: var(--base-px-14);
		color: #333333;
	}

	&-b {
		margin-top: var(--base-px-13);
		font-weight: 400;
		font-size: var(--base-px-14);
		color: #666666;
	}

	&-c {
		margin-top: var(--base-px-7);
		font-weight: bold;
		font-size: var(--base-px-36);
		color: #333333;
	}

	&-d {
		margin-top: var(--base-px-36);
		border-bottom: var(--base-px-1) solid #CCCCCC;
		padding-bottom: var(--base-px-12);
		font-weight: 400;
		font-size: var(--base-px-12);
		color: #666666;
	}

	&-e {
		margin-top: var(--base-px-11);
		border-bottom: var(--base-px-1) solid #CCCCCC;
		padding-bottom: var(--base-px-12);
		font-weight: 400;
		font-size: var(--base-px-12);
		color: #666666;
	}

	&-f {
		&-l {
			width: 45%;
			height: var(--base-px-41);
			background: #FFFFFF;
			border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
			border: var(--base-px-1) solid #CCCCCC;
			font-weight: 500;
			font-size: var(--base-px-12);
			color: #666666;
		}

		&-r {
			width: 45%;
			height: var(--base-px-41);
			background: #1A89F9;
			border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
			font-weight: 500;
			font-size: var(--base-px-12);
			color: #FFFFFF;
		}
	}
}

.recharge {
	padding: var(--base-px-12);
	height: calc(100% - var(--base-px-48));
	background: #F7F8FC;

	&-top {
		background-image: url("../../assets/my/1.png");
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover; /* 或者使用 100% 100% */
		width: var(--base-px-351);
		height: var(--base-px-123);
		padding: var(--base-px-32) var(--base-px-24);

		&-t {
			font-weight: 400;
			font-size: var(--base-px-14);
			color: #FFFFFF;
			line-height: var(--base-px-20);
		}

		&-b {
			font-weight: bold;
			font-size: var(--base-px-24);
			color: #FFFFFF;
			line-height: var(--base-px-33);
			padding-top: var(--base-px-6);
		}
	}

	&-c {
		margin-top: var(--base-px-16);

		&-t {
			font-weight: bold;
			font-size: var(--base-px-14);
			color: #333333;
			line-height: var(--base-px-20);
		}

		&-c {
			margin-top: var(--base-px-12);

			.item-col {
				width: calc(33.333% - var(--base-px-12)); /* 三列布局，减去间距 */
				margin: 0 var(--base-px-6) var(--base-px-12) var(--base-px-6); /* 左右6px间距，底部12px间距 */
				box-sizing: border-box;
				float: left;
			}

			&-i {
				font-weight: bold;
				font-size: var(--base-px-14);
				background: #CEE6FF;
				border-radius: var(--base-px-4) var(--base-px-4) var(--base-px-4) var(--base-px-4);
				color: #1A89F9;
				height: var(--base-px-36);

				&-selected {
					background: #1A89F9;
					color: #FFFFFF;
				}
			}
		}

		&-b {
			position: fixed;
			bottom: 0;
			background: #ffffff;
			left: 0;
			right: 0;
			height: var(--base-px-53);
			padding: var(--base-px-6) var(--base-px-12) var(--base-px-6) var(--base-px-20);

			&-l {
				font-weight: bold;
				font-size: var(--base-px-16);
				color: #1A89F9;

				span {
					color: #333333;
					font-size: var(--base-px-12);
				}
			}

			&-r {
				width: var(--base-px-159);
				height: var(--base-px-41);
				background: #1A89F9;
				border-radius: var(--base-px-21) var(--base-px-21) var(--base-px-21) var(--base-px-21);
				font-weight: 500;
				font-size: var(--base-px-12);
				color: #FFFFFF;
			}
		}

		&-tips {
			font-weight: 400;
			font-size: var(--base-px-12);
			color: #999999;
		}
	}
}
</style>